import React from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';

const HotelsSearchMask = ({code}) => {
  return (
    <div className="hotelSearchMask">
      <Iframe
        url={`//www.booking.com/${code}`}
        position="absolute"
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="no"
      />
    </div>
  );
};

export default HotelsSearchMask;

HotelsSearchMask.propTypes = {
  code: PropTypes.string.isRequired
};
